<nb-card
  [ngStyle]="{
    'width': layoutService.widthByNb[sheetDialogNb]
      ? layoutService.widthByNb[sheetDialogNb]
      : layoutService.widthByNb[5]
  }"
>

      @if (!perimeter) {
        <app-circular-spinner [whiteBackground]="true"></app-circular-spinner>
      }

      <div class="button-groups">
        @if (canEditSite$ | async) {
          <button (click)="openEditSite()">
            <i class="fa-light fa-pen-to-square"></i>
          </button>
        }
        @if (canAccessAudit$ | async) {
          <button (click)="goToAudit()">
            <fa-icon icon="mobile-notch" class="fat" size="md"></fa-icon>
          </button>
        }
        @if ((perimeter && energyEnabled$ | async) && selectedView === 'energy') {
          <button nbButton status="primary" (click)="openEnergySettingsDialog('energyObjectives')">
            <i class="fa-kit fa-thin-gear-circle-bolt"></i>
          </button>
        }
        @if (perimeter && canAccessReport$ | async) {
          <button
            nbButton
            ghost
            [nbPopover]="reportsTemplate"
            nbPopoverPlacement="left"
            nbPopoverAdjustment="noop"
          >
            <i class="fa-light fa-file-chart-column"></i>
          </button>
        }
        <button nbButton status="primary" (click)="confirmClose()">
          <i class="fa-light fa-x"></i>
        </button>
      </div>

      @if (perimeter) {
        <!-- header start -->
        <nb-card-header class="p-0 perimeter-picture" [style.background]="perimeterPicture ? 'url(' + perimeterPicture + ')' : ''">

          @if (!perimeterPicture) {
            <div class="no-picture" [nbSpinner]="loadingPicture">
            </div>
          }

          @if (!loadingPicture && perimeterPicture) {
            <div class="picture-gradient"></div>
          }

          <div class="site-name-container">
            <span class="name">{{ perimeter.name }}</span>
            @if (selectedView === 'energy' && isFidjiAct) {
              <app-perimeter-selector [multiPerimeter]="perimeter"></app-perimeter-selector>
            }
          </div>

          <!-- first line of tabs -->
          <div class="choose-view">

            <span [class]="selectedView === 'main-info' ? 'selected' : ''" (click)="changeView('main-info')">
              {{ "General information of the site" | translate }}
            </span>

            @if (canAccessObligations$ | async) {
              <span [class]="selectedView === 'obligations' ? 'selected' : ''" (click)="changeView('obligations')">
                {{ "Regulatory obligations" | translate }}
              </span>
            }

            <span [class]="selectedView === 'ppa' ? 'selected' : ''" (click)="changeView('ppa')">
              {{ "Investments" | translate }}
            </span>

            @if (showInitiatives$ | async) {
              <span [class]="selectedView === 'actions' ? 'selected' : ''" (click)="changeView('actions')">
                {{ "Energy / Carbon Actions" | translate }}
              </span>
            }

            <span [class]="selectedView === 'assets' ? 'selected' : ''" (click)="changeView('assets')">
              {{ "Equipments" | translate }}
            </span>

            @if ((energyEnabled$ | async); as energyEnabled) {
              <span [class]="selectedView === 'energy' ? 'selected' : ''" (click)="changeView('energy')">
                {{ "RSE energy carbon trajectory" | translate }}
              </span>
            }
          </div>

        </nb-card-header>
        <!-- header end -->
      }

      @if (perimeter) {
        <nb-card-body class="p-1">
          <div class="row h-100 page-wrapper m-0">

            <div class="site-content h-100">

              @if (selectedView === 'main-info') {
                <div class="col-12 reference-data-loading-host h-100">
                  @if (referenceDataLoading) {
                    <app-circular-spinner [whiteBackground]="true"></app-circular-spinner>
                  }
                  <app-site-main-info-tabs
                    [perimeter]="perimeter"
                    [perimeterStats]="perimeterStats"
                    [isFidjiAct]="isFidjiAct"
                    [focusedPerimeterId]="focusedPerimeterId"
                    [refreshKey]="referenceDataRefreshKey"
                  ></app-site-main-info-tabs>
                </div>
              }

              @if (selectedView === 'obligations' && (canAccessObligations$ | async)) {
                <div class="col-12 table inv">
                  <app-site-obligations-reglementaires
                    [perimeterId]="perimeter.id"
                    [perimeter]="perimeter"
                  ></app-site-obligations-reglementaires>
                </div>
              }

              @if (selectedView === 'reports') {
                <div class="col-12 pt-5">
                  <app-site-control-reports [perimeterId]="perimeter.id"></app-site-control-reports>
                </div>
              }

              @if (selectedView === 'ppa') {
                <div class="col-12 table inv">
                  <app-investments-spreadsheet
                    [investmentsListFilter]="tablesFilter"
                  ></app-investments-spreadsheet>
                </div>
              }

              @if (selectedView === 'actions') {
                <div class="col-12 table">
                  <app-initiatives-spreadsheet
                    [inputFilters]="tablesFilter"
                    [inputScenario]="scenario"
                    [minimizedView]="true"
                    [showScenarii]="false"
                  ></app-initiatives-spreadsheet>
                </div>
              }

              @if (selectedView === 'assets') {
                <div class="col-12 table inv">
                  <div class="row header-container">
                    <div class="col-lg-9 spreadsheet-summary">
                      {{ 'pages.insight.assets.selected_assets_summary' | translate:{
                      nextCapex: techStateAssets.nextCapex,
                      selectedTechStateAssetsNb: techStateAssets.techStateAssetsNb
                      } }}
                    </div>
                    <div class="col-lg-3 px-0">
                      <app-table-filter [filtersNb]="filtersNb" [tableType]="'asset'">
                      </app-table-filter>
                    </div>
                  </div>
                  <app-ag-grid-asset
                    #grid
                    [assetsListFilter]="tablesFilter"
                    [fullHeight]="true"
                    (totalAsset)="totalAssetChanged($event)"
                    (filtersNb)="filtersNb = $event"
                    [showTotals]="true"
                    [filterContext]="'site-overview'"
                  >
                  </app-ag-grid-asset>
                </div>
              }

              @if (selectedView === 'energy') {
                <app-rse-energy-carbon-prevision [perimeter]="focusedPerimeter$ | async"></app-rse-energy-carbon-prevision>
              }

            </div>

          </div>
        </nb-card-body>
      }

</nb-card>

<ng-template #reportsTemplate>
  <app-site-overview-reports [perimeter]="perimeter"></app-site-overview-reports>
</ng-template>
